import { get, isEmpty } from 'lodash';
import { createInstance, createStandardApi, Dashboard } from 'piral';
import IFrame2 from '../components/IFrame2';
import Loans from '../components/Loans';
import ProfileSDK from '../components/ProfileSDK/index';
import { pilets } from '../configs/config';
import { errors, layout } from '../layout';
import { EVENTS, PATHS, STORAGE_KEYS } from './constants';

import { gamification } from '../api/event';
import Customers from '../components/Customers';
import LoadTools from '../components/loadTools';
import TraderUI from '../components/TraderUI';
import { getItem, setItem } from './Storage';
import { redirectTo } from './utils';

const initialData = {
  selectedTile: [],
  count: 0,
  from: '',
  baseCount: 0,
  authData: {},
  dashboardData: {},
  kycInfo: {}
};
export const initializeContainer = {
  data: initialData,
  customDomain: process.env.CUSTOM_DOMAIN,

  update: (otherData: typeof initialData): void => {
    initializeContainer.data = { ...initializeContainer.data, ...otherData };

    instance.emit('update', initializeContainer.data);
  },
  updateBaseCount: (count) => {
    initializeContainer.data = {
      ...initializeContainer.data,
      baseCount: count
    };
    instance.emit('updateBaseCount', initializeContainer.data);
  },
  updateKycInfo: (kycInfo) => {
    initializeContainer.data = {
      ...initializeContainer.data,
      kycInfo
    };
  },

  setAuthData: (authenticationInfo) => {
    initializeContainer.data = {
      ...initializeContainer.data,
      authData: authenticationInfo.authData,
      dashboardData: authenticationInfo.authData
    };

    let realms = get(authenticationInfo, 'authData.realms[0]', {});
    if (isEmpty(realms)) {
      //submitOtpState?.data?.userRealmsDetails?.realms[0]
      realms = get(
        authenticationInfo,
        'authData.userRealmsDetails.realms[0]',
        {}
      );
    }

    let paymentsConfig = getItem(STORAGE_KEYS.PAYMENTS_CONFIG);

    setItem(STORAGE_KEYS.PAYMENTS_CONFIG, {
      ...authenticationInfo.authData,
      ...realms,
      ...paymentsConfig,
      bnplCallBakcRedirectURL: `${window.location.origin}/ninjapay`,
      contactNumber: authenticationInfo.authData.contactNumber
    });
    setItem(STORAGE_KEYS.AUTH_CONFIG, authenticationInfo.authData);
    setItem(STORAGE_KEYS.DASHBOARD_DATA, authenticationInfo.authData);
    setItem(STORAGE_KEYS.STATE, initializeContainer.data);

    setItem(STORAGE_KEYS.CUSTOM_DOMAIN, process.env.CUSTOM_DOMAIN);
    gamification({
      type: EVENTS.LOGIN,
      name: EVENTS.LOGIN
    });
    const appName = getItem(STORAGE_KEYS.APP_NAME);
    if (appName) {
      redirectTo(`/${appName}`);
    } else {
      redirectTo('/');
    }
  }
};

export const globalActions = {
  captureEvent: (event) => {
    gamification(event);
  },
  closeApp: (path = '/') => {
    redirectTo(path);
  },
  openLoans: (loanInfo) => {
    if (loanInfo.from === 'ekyc') {
      const primaryUser = get(loanInfo, 'primaryUser', {});
      const realmId = primaryUser?.realmId || primaryUser?.realmIdentifier;
      let link = `loans?userId=${primaryUser?.userId}&realmId=${realmId}&loanId=${loanInfo?.loanId}&applicationName=${loanInfo?.applicationName}&name=${primaryUser?.name}`;
      if (isEmpty(loanInfo?.loanId) && isEmpty(loanInfo?.applicationName)) {
        link = `loans?userId=${primaryUser?.userId}&realmId=${realmId}&name=${primaryUser?.name}`;
      }
      redirectTo(link);
    }
  }
};

const globalStoreFunction = () => {
  const globalStore = initializeContainer;
  return () => ({
    globalStore,
    globalActions
  });
};

export const instance = createInstance({
  state: {
    components: {
      ...layout
    },
    errorComponents: {
      ...errors
    },
    routes: {
      '/': Dashboard,
      [`/toolId/:toolId`]: LoadTools,
      [`/profile/:appName`]: ProfileSDK,
      // "/Dunzo1": () => IFrame2({ url: "https://www.Dunzo.com" }),
      // '/CargoFL': () => IFrame2({ url: process.env.CARGO_FL }),
      // "/TestProvider": () => IFrame2({ url: "https://www.test.in" }),
      // "/Gimbook": () => IFrame2({ url: "https://www.gimbooks.com/web/login/" }),
      // "/TallyWiz (Suvit)": () => IFrame2({ url: "https://www.suvit.io" }),
      '/profile': ProfileSDK,
      [PATHS.LOANS]: Loans,
      // [PATHS.LENDING_LOANS]: Loans,
      [PATHS.ONBEHALF_OF]: Customers,
      '/trader-app': TraderUI,
      [PATHS.MY_CUSTOMERS]: Customers,
      '/Ninjacart': Dashboard
    }
  },

  plugins: [...createStandardApi(), globalStoreFunction()],
  requestPilets() {
    // if (isEmpty(userInfo)) {
    // 	const result = new Promise((resolve, reject) => {
    // 		resolve(pilets.filter(({ name }) => name === "login"));
    // 	});
    // 	return result;
    // }

    // NetworkApi.get(paths.tools(), {
    //   'Content-Type': 'application/json',
    //   authorization: `${token_type} ${token}`
    // });
    const result = new Promise((resolve, reject) => {
      resolve(pilets);
    });

    return result;
  }
});
